import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VTabs,
        {
          attrs: { "center-active": "", "fixed-tabs": "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(VTab, [_vm._v(_vm._s("Periodos a Ejecutar"))]),
          _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.description")))]),
          _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.input_attributes")))]),
          _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.output_attributes")))]),
          _c(VTab, [_vm._v(_vm._s(_vm.$t("titles.logs")))]),
        ],
        1
      ),
      _c(
        VTabsItems,
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            VTabItem,
            [
              _c(
                VContainer,
                { attrs: { fluid: "" } },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "4", sm: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              label: "Mes",
                              items: _vm.months,
                              "item-text": "name",
                              "item-value": "value",
                              outlined: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.selectedMonth,
                              callback: function ($$v) {
                                _vm.selectedMonth = $$v
                              },
                              expression: "selectedMonth",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4", sm: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              label: "Año",
                              items: _vm.years,
                              "item-text": "name",
                              "item-value": "value",
                              outlined: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.selectedYear,
                              callback: function ($$v) {
                                _vm.selectedYear = $$v
                              },
                              expression: "selectedYear",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4", sm: "4" } },
                        [
                          _c(
                            VBtn,
                            {
                              attrs: {
                                color: "primary",
                                disabled: _vm.chips.length >= _vm.maxChips,
                              },
                              on: { click: _vm.addChip },
                            },
                            [_vm._v("Agregar")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            VChipGroup,
                            { attrs: { column: "" } },
                            _vm._l(_vm.chips, function (chip, index) {
                              return _c(
                                VChip,
                                {
                                  key: chip.id,
                                  staticClass: "caption small m-1",
                                  attrs: { color: "primary", close: "" },
                                  on: {
                                    "click:close": function ($event) {
                                      return _vm.removeChip(index)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(chip.display) + " ")]
                              )
                            }),
                            1
                          ),
                          !_vm.isValidChips
                            ? _c("p", { staticClass: "error--text" }, [
                                _vm._v(
                                  "Debes seleccionar al menos un periodo."
                                ),
                              ])
                            : _vm._e(),
                          _vm.chips.length >= _vm.maxChips
                            ? _c("p", { staticClass: "error--text" }, [
                                _vm._v(
                                  " Máximo " +
                                    _vm._s(_vm.maxChips) +
                                    " periodos. "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _c(
                VContainer,
                { attrs: { fluid: "" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_productize_usecase.organization"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.info.organization,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "organization", $$v)
                              },
                              expression: "info.organization",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_productize_usecase.use_case"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.info.use_case,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "use_case", $$v)
                              },
                              expression: "info.use_case",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { staticClass: "mt-2", attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("form_attrs_productize_usecase.user")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(
                            VChipGroup,
                            [
                              _c(VChip, { staticClass: "mr-1" }, [
                                _vm._v(_vm._s(_vm.info.owner_name)),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_productize_usecase.destination_scheme"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.info.destination_scheme,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "destination_scheme", $$v)
                              },
                              expression: "info.destination_scheme",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_productize_usecase.segment"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                            },
                            model: {
                              value: _vm.info.segment,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "segment", $$v)
                              },
                              expression: "info.segment",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _vm.item.tipo_registro.toLowerCase() == "binning"
                        ? [
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Tipo de transformación")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "9", lg: "4" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    filled: "",
                                    readonly: "",
                                    "hide-details": "auto",
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.item.tipo_registro,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.item, "tipo_registro", $$v)
                                    },
                                    expression: "item.tipo_registro",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Tabla generada (AWS)")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "9", lg: "4" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    filled: "",
                                    readonly: "",
                                    "hide-details": "auto",
                                    dense: "",
                                    value: _vm.awsTableName,
                                  },
                                  on: {
                                    "click:append-outer": _vm.copyAwsTableName,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c(
                    VRow,
                    { staticClass: "mt-2", attrs: { dense: "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_productize_usecase.description"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextarea, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                              rows: "2",
                            },
                            model: {
                              value: _vm.info.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "description", $$v)
                              },
                              expression: "info.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "3", lg: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("form_attrs_productize_usecase.model")
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9", lg: "4" } },
                        [
                          _c(VTextarea, {
                            attrs: {
                              filled: "",
                              readonly: "",
                              "hide-details": "auto",
                              dense: "",
                              rows: "1",
                            },
                            model: {
                              value: _vm.info.model,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "model", $$v)
                              },
                              expression: "info.model",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _c(VDataTable, {
                key: _vm.keyTable,
                staticClass: "text-center table-inca",
                attrs: {
                  headers: _vm.internal_headers,
                  items: _vm.tableInternalItems,
                  "item-key": "id",
                  "group-by": "attribute_category",
                  responsive: "",
                  "hide-default-footer": "",
                  "items-per-page": _vm.pagination.attributes.limit,
                  page: _vm.pagination.attributes.current,
                  "show-expand":
                    _vm.item.tipo_registro.toLowerCase() == "binning",
                  expanded: _vm.expandedRows,
                  "single-expand": "",
                },
                on: {
                  pagination: function ($event) {
                    _vm.pagination.attributes.total = $event.itemsLength
                  },
                  "update:page": function ($event) {
                    return _vm.$set(
                      _vm.pagination.attributes,
                      "current",
                      $event
                    )
                  },
                  "update:expanded": function ($event) {
                    _vm.expandedRows = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "group.header",
                    fn: function (ref) {
                      var group = ref.group
                      return [
                        _c("td", { attrs: { colspan: "4" } }, [
                          _c("strong", [_vm._v(_vm._s(group))]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "expanded-item",
                    fn: function (ref) {
                      var headers = ref.headers
                      var item = ref.item
                      return [
                        _c("td", { attrs: { colspan: headers.length } }, [
                          _c(
                            "div",
                            { staticClass: "text-left pa-3" },
                            [
                              _c("div", { staticClass: "mb-1" }, [
                                _vm._v("Intervalos: "),
                              ]),
                              _c(VSimpleTable, {
                                attrs: { dense: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function () {
                                        return [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "caption text--secondary font-weight-medium text-center",
                                                },
                                                [_vm._v("Condición")]
                                              ),
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "caption text--secondary font-weight-medium text-center",
                                                },
                                                [_vm._v(" Resultado ")]
                                              ),
                                            ]),
                                          ]),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              item.ranges,
                                              function (r, i) {
                                                return _c("tr", { key: i }, [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      r.default
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2 font-weight-medium",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "En cualquier otro caso"
                                                              ),
                                                            ]
                                                          )
                                                        : r.isNull
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2 font-weight-medium",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Cuando el valor es nulo"
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2 font-weight-medium",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Valor " +
                                                                  _vm._s(r.op) +
                                                                  " " +
                                                                  _vm._s(
                                                                    r.value
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-2 font-weight-bold",
                                                          staticStyle: {
                                                            "font-variant-numeric":
                                                              "tabular-nums",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(r.output) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("pagination-vue", {
                attrs: { pagination: _vm.pagination.attributes },
              }),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _c(VDataTable, {
                key: _vm.keyTable2,
                staticClass: "text-center table-inca",
                attrs: {
                  headers: _vm.output_headers,
                  items: _vm.tableOutputItems,
                  "item-key": "id",
                  responsive: "",
                  "hide-default-footer": "",
                  "items-per-page": _vm.pagination.output.limit,
                  page: _vm.pagination.output.current,
                },
                on: {
                  pagination: function ($event) {
                    _vm.pagination.output.total = $event.itemsLength
                  },
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.output, "current", $event)
                  },
                },
              }),
              _c("pagination-vue", {
                attrs: { pagination: _vm.pagination.output },
              }),
            ],
            1
          ),
          _c(
            VTabItem,
            [
              _c(VDataTable, {
                key: _vm.keyTable3,
                staticClass: "text-center table-inca",
                attrs: {
                  responsive: "",
                  dense: "",
                  items: _vm.logItems,
                  headers: _vm.log_headers,
                  "hide-default-footer": "",
                  "sort-by": _vm.pagination.logs.sort_by,
                  "sort-desc": _vm.pagination.logs.sort_desc,
                  "items-per-page": _vm.pagination.logs.limit,
                  page: _vm.pagination.logs.current,
                },
                on: {
                  pagination: function ($event) {
                    _vm.pagination.logs.total = $event.itemsLength
                  },
                  "update:page": function ($event) {
                    return _vm.$set(_vm.pagination.logs, "current", $event)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.creation_date",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(VIcon, [_vm._v(" mdi-calendar ")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getDateAndHours(item.creation_date).date
                            ) +
                            " "
                        ),
                        _c(VIcon, [_vm._v(" mdi-clock-outline ")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getDateAndHours(item.creation_date).hour
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.environment",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          VChip,
                          {
                            attrs: {
                              small: "",
                              color:
                                item.environment === "prd"
                                  ? "#6200ea"
                                  : "default",
                              "text-color": "white",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.environment
                                    ? item.environment.toUpperCase()
                                    : ""
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("pagination-vue", {
                attrs: { pagination: _vm.pagination.logs },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }